import { put, call, all, takeEvery, takeLatest } from 'redux-saga/effects'
import { store as reduxStore } from 'index'
import { push } from 'react-router-redux'
import {
  list as apikeysList,
  listByScope as apikeysListByScope,
  add as apikeyAdd,
  get as apikeyGet,
  update as apikeyUpdate,
  search as apikeysSearch,
  del as apikeyDelete,
} from 'services/apikeys'
import _ from 'lodash'
import { getAppHost } from 'helpers'
import actions from './actions'

export function* API_KEYS_LIST({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      areApikeysLoading: true,
    },
  })

  if (!payload.data) payload.data = reduxStore.getState().apps.active
  if (!payload.appSettings) payload.appSettings = reduxStore.getState().apps.appSettings

  try {
    const success = yield call(apikeysList, payload.data, getAppHost(payload.appSettings), 1)

    if (success && success.data) {
      let totalApikeyCount = success.data.length
      let totalApikeyAuthCount = reduxStore.getState().apiKeys.apikeysListAuthTotal
      let totalApikeyRestCount = reduxStore.getState().apiKeys.apikeysListRestTotal
      let apikeyAuthList = reduxStore.getState().apiKeys.apikeysAuthList
      let apikeyRestList = reduxStore.getState().apiKeys.apikeysRestList
      const apikeysAuthPagination = reduxStore.getState().apiKeys.apikeysAuthListPagination
      const apikeysRestPagination = reduxStore.getState().apiKeys.apikeysRestListPagination

      let pageNoAuth = payload.currentPage
      if (pageNoAuth === undefined && apikeysAuthPagination.current_page !== undefined)
        pageNoAuth = apikeysAuthPagination.current_page + 1

      let pageNoRest = payload.currentPage
      if (pageNoRest === undefined && apikeysRestPagination.current_page !== undefined)
        pageNoRest = apikeysRestPagination.current_page + 1

      if (payload.keyScope !== undefined && payload.keyScope === 'authKey') {
        pageNoAuth = payload.currentPage
        pageNoRest = apikeysRestPagination.current_page
      } else if (payload.keyScope !== undefined && payload.keyScope === 'restKey') {
        pageNoRest = payload.currentPage
        pageNoAuth = apikeysAuthPagination.current_page
      }

      if (success.meta && success.meta.pagination && success.meta.pagination.total_pages) {
        totalApikeyCount = success.meta.pagination.total_pages * success.meta.pagination.per_page
      }

      let qsKey = 'API_KEY'
      let successRestType = []
      let successAuthType = []

      let apikeysAuthListPagination = apikeysAuthPagination
      let apikeysRestListPagination = apikeysRestPagination

      if (success.data.length > 0) {
        if (payload.scope && (payload.scope === 'restKey' || payload.scope === 'authKey')) {
          if (payload.scope === 'restKey') {
            successRestType = yield call(
              apikeysListByScope,
              payload.data,
              getAppHost(payload.appSettings),
              pageNoRest,
              'fullAccess',
            )
          } else {
            successAuthType = yield call(
              apikeysListByScope,
              payload.data,
              getAppHost(payload.appSettings),
              pageNoAuth,
              'authOnly',
            )
          }
        } else {
          successAuthType = yield call(
            apikeysListByScope,
            payload.data,
            getAppHost(payload.appSettings),
            pageNoAuth,
            'authOnly',
          )

          successRestType = yield call(
            apikeysListByScope,
            payload.data,
            getAppHost(payload.appSettings),
            pageNoRest,
            'fullAccess',
          )
        }

        if (successAuthType && successAuthType.data) {
          apikeyAuthList = successAuthType.data

          totalApikeyAuthCount = successAuthType.data.length

          if (
            successAuthType.meta &&
            successAuthType.meta.pagination &&
            successAuthType.meta.pagination.total_pages
          ) {
            totalApikeyAuthCount =
              successAuthType.meta.pagination.total_pages * successAuthType.meta.pagination.per_page
            apikeysAuthListPagination = successAuthType.meta.pagination
          }

          let qsKeyIndex = _.findLastIndex(success.data, function fn(ak) {
            return _.toLower(_.trim(ak.name)) === 'auth key' && ak.scope === 'authOnly'
          })
          if (qsKeyIndex < 0) {
            qsKeyIndex = _.findLastIndex(success.data, function fn(ak) {
              return ak.scope === 'authOnly'
            })
            if (qsKeyIndex < 0) {
              qsKey = 'API_KEY'
            } else {
              qsKey = success.data[qsKeyIndex].apiKey
            }
          }
        }

        if (successRestType && successRestType.data) {
          apikeyRestList = successRestType.data
          totalApikeyRestCount = successRestType.data.length

          if (
            successRestType.meta &&
            successRestType.meta.pagination &&
            successRestType.meta.pagination.total_pages
          ) {
            totalApikeyRestCount =
              successRestType.meta.pagination.total_pages * successRestType.meta.pagination.per_page
            apikeysRestListPagination = successRestType.meta.pagination
          }
        }
      }

      yield put({
        type: actions.SET_STATE,
        payload: {
          apikeysList: success.data,
          apikeysListTotal: totalApikeyCount,
          apikeysAuthList: apikeyAuthList,
          apikeysListAuthTotal: totalApikeyAuthCount,
          apikeysRestList: apikeyRestList,
          apikeysListRestTotal: totalApikeyRestCount,
          apikeysRestListPagination,
          apikeysAuthListPagination,
          apikeyQuickStart: qsKey,
          areApikeysLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          apikeysListTotal: 0,
          apikeysList: [],
          apikeysAuthList: [],
          apikeysListAuthTotal: 0,
          apikeysRestList: [],
          apikeysListRestTotal: 0,
          apikeysRestListPagination: {},
          apikeysAuthListPagination: {},
          apikeyQuickStart: 'API_KEY',
          areApikeysLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: { areApikeysLoading: false },
    })
    window.triggerNotification('Failed to fetch API keys', 'error')
  }
}

export function* GET_APIKEY({ payload }) {
  const { id } = payload
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  try {
    const success = yield call(apikeyGet, id, activeApp, getAppHost(appSettings))
    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          apikeysActive: success.data,
        },
      })
    } else {
      yield put(push(`/app/${activeApp.id}/credentials`))
    }
  } catch (error) {
    window.triggerNotification('Failed to fetch API key', 'error')
  }
}

export function* ADD_APIKEY({ payload }) {
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  try {
    const success = yield call(apikeyAdd, payload, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.API_KEYS_LIST,
        payload: {
          currentPage: 1,
          data: activeApp,
          appSettings,
          keyScope: payload.scope === 'authOnly' ? 'authKey' : 'restKey',
        },
      })
      if (!payload.hideNotification) {
        window.triggerNotification(
          payload.scope === 'authOnly' ? 'Auth Key created.' : 'REST API Key created.',
          'success',
        )
      }
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
      if (!payload.hideNotification) {
        window.triggerNotification(success.error.details.name, 'error')
      }
    }
  } catch (error) {
    window.triggerNotification('Failed to add API key', 'error')
  }
}

export function* ENTER_APIKEY_TEXT({ payload }) {
  const { searchText } = payload
  yield put({
    type: actions.SET_STATE,
    payload: {
      apikeySearchText: searchText,
    },
  })
  if (searchText.length === 0 || searchText.length >= 2) {
    yield put({
      type: actions.SEARCH_APIKEY,
      payload: {},
    })
  }
}

export function* SEARCH_APIKEY() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      areApikeysLoading: true,
    },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps
  const searchText = reduxStore.getState().apiKeys.apikeySearchText

  try {
    const success = yield call(apikeysSearch, activeApp, getAppHost(appSettings), searchText)

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          apikeysList: success.data,
          areApikeysLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          areApikeysLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: { areApikeysLoading: false },
    })
    window.triggerNotification('Failed to search API keys', 'error')
  }
}

export function* UPDATE_APIKEY({ id, payload }) {
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  try {
    const success = yield call(apikeyUpdate, id, payload, activeApp, getAppHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.API_KEYS_LIST,
        payload: { currentPage: 1, data: activeApp, appSettings },
      })
      window.triggerNotification('API Key saved', 'success')
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
      window.triggerNotification(success.error.details.name, 'error')
    }
  } catch (error) {
    window.triggerNotification('Failed to update API key', 'error')
  }
}

export function* DELETE_APIKEY({ payload }) {
  const { id, refresh, keyScope } = payload

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps
  const {
    apikeysAuthListPagination,
    apikeysRestListPagination,
  } = reduxStore.getState().apiKeys

  try {
    const success = yield call(apikeyDelete, id, activeApp, getAppHost(appSettings))
    let apiKeysListPageNo = 1
    if (keyScope === 'authKey') {
      apiKeysListPageNo =
        apikeysAuthListPagination !== undefined && apikeysAuthListPagination.count > 1
          ? apikeysAuthListPagination.current_page
          : 1
    } else if (keyScope === 'restKey') {
      apiKeysListPageNo =
        apikeysRestListPagination !== undefined && apikeysRestListPagination.count > 1
          ? apikeysRestListPagination.current_page
          : 1
    }

    if (success && success.data) {
      yield put({
        type: actions.API_KEYS_LIST,
        payload: { currentPage: apiKeysListPageNo, data: activeApp, appSettings, keyScope },
      })
      window.triggerNotification('API Key deleted', 'success')
      if (refresh) yield put(push(`/app/${activeApp.id}/credentials`))
    } else if (success.error.code === 'ERR_BAD_REQUEST') {
      window.triggerNotification(success.error.details.name, 'error')
    }
  } catch (error) {
    window.triggerNotification('Failed to delete API key', 'error')
  }
}

export default function* apiKeysSaga() {
  yield all([
    takeEvery(actions.API_KEYS_LIST, API_KEYS_LIST),
    takeEvery(actions.GET_APIKEY, GET_APIKEY),
    takeEvery(actions.ADD_APIKEY, ADD_APIKEY),
    takeEvery(actions.ENTER_APIKEY_TEXT, ENTER_APIKEY_TEXT),
    takeLatest(actions.SEARCH_APIKEY, SEARCH_APIKEY),
    takeEvery(actions.UPDATE_APIKEY, UPDATE_APIKEY),
    takeEvery(actions.DELETE_APIKEY, DELETE_APIKEY),
  ])
}
